import { View, StyleSheet } from "react-native";
import { useTheme } from "@/hooks/useTheme";
import { SearchZone } from "./SearchZone";
import { SelectionZone } from "./SelectionZone";
import { ActionZone } from "./ActionZone";
import type { ActionBarProps } from "./types";

export function ActionBar({
  search,
  selection,
  dirty,
  onRefresh,
  actions,
  leftSlot,
  centerSlot,
  rightSlot,
  style,
}: ActionBarProps) {
  const { colors } = useTheme();

  // Determine what to render in each zone
  const hasLeft = leftSlot !== undefined || search !== undefined;
  const hasCenter = centerSlot !== undefined || selection !== undefined;
  const hasRight =
    rightSlot !== undefined || onRefresh !== undefined || dirty !== undefined || (actions && actions.length > 0);

  const renderDivider = () => <View style={[styles.divider, { backgroundColor: colors.border }]} />;

  return (
    <View style={[styles.container, style]}>
      {/* Left zone: search or custom slot */}
      {leftSlot !== undefined ? leftSlot : search ? <SearchZone config={search} /> : null}

      {/* Divider between left and center */}
      {hasLeft && hasCenter && renderDivider()}

      {/* Center zone: selection or custom slot */}
      {centerSlot !== undefined ? centerSlot : selection ? <SelectionZone config={selection} /> : null}

      {/* Spacer to push action zone to the right */}
      <View style={styles.spacer} />

      {/* Right zone: actions or custom slot */}
      {rightSlot !== undefined ? (
        rightSlot
      ) : hasRight ? (
        <ActionZone onRefresh={onRefresh} dirty={dirty} actions={actions} />
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  divider: {
    width: 1,
    height: 24,
    marginHorizontal: 4,
  },
  spacer: {
    flex: 1,
  },
});
